export const CREATE_USER_DRAWER_ID = 'create-user-drawer';
export const CREATE_ORG_DRAWER_ID = 'create-org-drawer';
export const EDIT_ORG_DRAWER_ID = 'edit-org-drawer';
export const ACTIVE = 'active';
export const DEACTIVATED = 'deactivated';
export const INTERNAL = 'internal';
export const EXTERNAL = 'external';

export const USER_MANAGEMENT_READ =
  'app:dxm-user-management-panel:permissions:read';
export const USER_MANAGEMENT_CLIENT_CREDENTIALS_READ =
  'app:dxm-user-management-panel:client-credentials:read';
export const USER_MANAGEMENT_CLIENT_CREDENTIALS_WRITE =
  'app:dxm-user-management-panel:client-credentials:write';
export const USER_MANAGEMENT_WRITE =
  'app:dxm-user-management-panel:permissions:write';
export const USER_MANAGEMENT_ORG_ADMIN_ACCESS =
  'app:dxm-user-management-panel:org-admin-access';

export const INPUT_MAX_LENGTH = 50;
export const INPUT_MIN_LENGTH = 3;
export const INPUT_VALID_CHARS_REGEX = /^[A-Za-z0-9'_-\s]*$/;

export const DEBOUNCE_TIME = 300;
